function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7352 2.69861H7.68561V0.724609H5.68561V2.69861H2.60199C1.49742 2.69861 0.60199 3.59404 0.60199 4.69861V26.8345C0.60199 27.9391 1.49742 28.8345 2.60199 28.8345H26.602C27.7066 28.8345 28.602 27.9391 28.602 26.8345V4.69861C28.602 3.59404 27.7066 2.69861 26.602 2.69861H23.7352V1.0058L21.7352 1.0058V2.69861ZM2.60199 4.69861H26.602V7.95935H2.60199V4.69861ZM2.60199 9.95935V26.8345H26.602V9.95935H2.60199Z",
  fill: "black"
});

var SvgMeet = function SvgMeet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMeet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meet.fd2902e6.svg";
export { ForwardRef as ReactComponent };